import { errorMessage } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import invoiceSymbolService from "services/invoiceSymbolService";
import {
  INVOICE_SYMBOL_ACTIVE,
  INVOICE_SYMBOL_CREATE,
  INVOICE_SYMBOL_DELETE,
  INVOICE_SYMBOL_DETAIL,
  INVOICE_SYMBOL_LIST,
  INVOICE_SYMBOL_UPDATE,
} from "./actionTypes";
import {
  activeInvoiceSymbolFail,
  activeInvoiceSymbolSuccess,
  createInvoiceSymbolFail,
  createInvoiceSymbolSuccess,
  deleteInvoiceSymbolFail,
  deleteInvoiceSymbolSuccess,
  detailInvoiceSymbolFail,
  detailInvoiceSymbolSuccess,
  listInvoiceSymbolFail,
  listInvoiceSymbolSuccess,
  updateInvoiceSymbolFail,
  updateInvoiceSymbolSuccess,
} from "./actions";

function* fetchListInvoiceSymbol({ payload, isListManager }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      invoiceSymbolService.listInvoiceSymbol,
      payload,
      buStoreHeader,
      isListManager
    );
    yield put(listInvoiceSymbolSuccess(response));
  } catch (error) {
    yield put(listInvoiceSymbolFail(errorMessage(error)));
  }
}

function* onCreateInvoiceSymbol({ payload }) {
  try {
    const response = yield call(
      invoiceSymbolService.createInvoiceSymbol,
      payload
    );
    yield put(createInvoiceSymbolSuccess(response));
  } catch (error) {
    yield put(createInvoiceSymbolFail(errorMessage(error)));
  }
}

function* onDetailInvoiceSymbol({ payload }) {
  try {
    const response = yield call(
      invoiceSymbolService.detailInvoiceSymbol,
      payload
    );
    yield put(detailInvoiceSymbolSuccess(response));
  } catch (error) {
    yield put(detailInvoiceSymbolFail(errorMessage(error)));
  }
}

function* onUpdateInvoiceSymbol({ payload }) {
  try {
    const response = yield call(
      invoiceSymbolService.updateInvoiceSymbol,
      payload
    );
    yield put(updateInvoiceSymbolSuccess(response));
  } catch (error) {
    yield put(updateInvoiceSymbolFail(errorMessage(error)));
  }
}

function* onDeleteInvoiceSymbol({ payload }) {
  try {
    const response = yield call(
      invoiceSymbolService.deleteInvoiceSymbol,
      payload
    );
    yield put(deleteInvoiceSymbolSuccess(response));
  } catch (error) {
    yield put(deleteInvoiceSymbolFail(errorMessage(error)));
  }
}

function* onActiveInvoiceSymbol({ payload }) {
  try {
    const response = yield call(
      invoiceSymbolService.activeInvoiceSymbol,
      payload
    );
    yield put(activeInvoiceSymbolSuccess(response));
  } catch (error) {
    yield put(activeInvoiceSymbolFail(errorMessage(error)));
  }
}

function* invoiceSymbolSaga() {
  yield takeEvery(INVOICE_SYMBOL_LIST, fetchListInvoiceSymbol);
  yield takeEvery(INVOICE_SYMBOL_CREATE, onCreateInvoiceSymbol);
  yield takeEvery(INVOICE_SYMBOL_DETAIL, onDetailInvoiceSymbol);
  yield takeEvery(INVOICE_SYMBOL_UPDATE, onUpdateInvoiceSymbol);
  yield takeEvery(INVOICE_SYMBOL_DELETE, onDeleteInvoiceSymbol);
  yield takeEvery(INVOICE_SYMBOL_ACTIVE, onActiveInvoiceSymbol);
}

export default invoiceSymbolSaga;
